import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'question-note',
  templateUrl: './question-note.component.html',
  styleUrls: ['./question-note.component.scss']
})
export class QuestionNoteComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
